export default "__VITE_ASSET__l_HFvsY6__"